<template>
	<div class="aside-wrap">
		<div class="aside-title">
			<div class="title-l">
				<!-- <div class="title-icon">
					<img src="@/assets/news_icon.png" />
				</div> -->
				<h3>KylinOS资讯</h3>
			</div>
			<div @click="toNext()" class="title-r">
				<span >换一换</span>
				<img src="@/assets/change_icon.png" />
			</div>
		</div>
		<div class="aside-content">
			<ul>
				<li @click="toDetail(item)" v-for="(item,index) in dataList" :key="index">
					<span class="list-num">{{item.rank}}</span>
					<span class="list-cnt"><a href="javascript:;">{{item.postName||item.content}}</a></span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'AsideNews',
		components: {
		},
		data(){
			return {
				pageNum: 1,
				pageSize: 8,
				dataList: []
			}
		},
		created(){
			this.getDataList()
		},
		methods: {
      //换一换 最多三页  超过三页换回第一页，如果没数据，则不更新
      toNext(){
        if (this.pageNum<3){
          this.pageNum=this.pageNum+1;
        }else{
          this.pageNum=1
        }
        this.getDataList()
      },
      //获取数据列表
			async getDataList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/circle/consultPost', qs.stringify(param))
				if(res.data.code==200){
          if (res.data.list.length==0 && this.pageNum!=1){
            this.pageNum=1;
            this.getDataList();
          }else{
            this.dataList = res.data.list
          }
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toDetail(item){
				this.$router.push({
					path: '/detail?id='+item.id+'&type=' + item.categoryScene
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.title-r{
		display: flex;
		align-items: center;
		cursor: pointer;
		opacity: .7;
		font-size: 12px;
		img{
			width: 12px;
			height: 12px;
			margin-left: 4px;
		}
	}
	.aside-content{
		// padding: 20px;
		li{
			display: flex;
			align-items: center;
			margin-bottom: 12px;
			.list-num{
				display: block;
				width: 18px;
				height: 18px;
				background: #C5C4C5;
				margin-right: 5px;
				border-radius: 4px;
				text-align: center;
				line-height: 18px;
				color: #fff;
			}
			.list-cnt{
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			a:hover{
				color: #DD0515;
				text-decoration: underline;
			}
		}
		li:last-child{
			margin-bottom: 0;
		}
		li:nth-of-type(1){
			.list-num{
				background: linear-gradient(316deg, #EA3936 0%, #FF726C 100%);
			}
		}
		li:nth-of-type(2){
			.list-num{
				background: linear-gradient(316deg, #FF7E01 0%, #FF9A1D 100%);
			}
		}
		li:nth-of-type(3){
			.list-num{
				background: linear-gradient(316deg, #E0A56F 0%, #F5C380 100%);
			}
		}
	}
</style>
